import React from 'react';
import { routes } from '../routes/routes';
import { apiRoutes } from '../api/apiRoutes';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBox from '@mui/icons-material/AccountBox';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import Speed from '@mui/icons-material/Speed';
import Help from '@mui/icons-material/Help';
import BookIcon from '@mui/icons-material/Book';
import GroupsIcon from '@mui/icons-material/Groups';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import SidebarCardContainer from '../../app/components/plan/SidebarCardContainer/SidebarCardContainer';

export const companySidebarItems = [];

export const sidebarItems = [
  {
    title: 'SIDEBAR.GROUP_GENERAL',
    items: [
      {
        title: 'SIDEBAR.DASHBOARD',
        icon: <Speed />,
        url: routes.admin.dashboard,
      },
      {
        title: 'SIDEBAR.CLIENTS',
        icon: <GroupsIcon />,
        url: routes.admin.clients.list,
        apiUrl: apiRoutes.clients.list,
      },
      {
        title: 'SIDEBAR.VOCABULARY',
        icon: <BookIcon />,
        url: routes.admin.vocabulary,
        apiUrl: apiRoutes.vocabularyItem.list,
        enabled: false,
      },
      {
        title: 'SIDEBAR.DOCUMENTS',
        icon: <LibraryBooksIcon />,
        url: routes.admin.documents.list,
        apiUrl: apiRoutes.document.list,
        enabled: false,
      },
      {
        title: 'SIDEBAR.PLANS',
        icon: <CreditCardIcon />,
        url: routes.admin.plans,
        apiUrl: apiRoutes.plans.getInfo,
      },
      {
        title: 'SIDEBAR.HELP',
        icon: <Help />,
        url: routes.admin.help,
        apiUrl: apiRoutes.support.createTicket,
      },
    ],
  },
  {
    title: 'SIDEBAR.GROUP_SETTINGS',
    items: [
      {
        title: 'SIDEBAR.COMPANIES',
        icon: <BusinessIcon />,
        url: routes.admin.companies.list,
        apiUrl: apiRoutes.companies.list,
        enabled: process.env.REACT_APP_PLATFORM_ENABLED === 'true',
      },
      {
        title: 'SIDEBAR.USERS',
        icon: <AccountBox />,
        url: routes.admin.users.list,
        apiUrl: apiRoutes.users.list,
      },
      {
        title: 'SIDEBAR.TRANSLATIONS',
        icon: <SpellcheckIcon />,
        url: routes.admin.translations.list,
        apiUrl: apiRoutes.translations.list,
      },
    ],
  },
];

export const sidebarCheckinConfig = {
  enabled: false,
  statusApiUrl: '',
  startLabel: '',
  startApiUrl: '',
  endLabel: '',
  endApiUrl: '',
};

export const sidebarComponentConfig = {
  component: <SidebarCardContainer />,
};
